import ajax from '@/utils/ajax';

export const head = '/web';
const applets = '/applets';

// 获取用户个人档案
export const getArchivesInfoApi = () => ajax(`${head}/v1/lms/user-examination/detail`, '', 'GET');

// 提交个人档案
export const subArchivesInfoApi = (data) => ajax(`${head}/v1/lms/user-examination/submit`, data, 'POST');

// 模糊搜索本科学校
export const getSchoolApi = (value) => ajax(`${applets}/v1/academy/act/match-university?name=${value}&pageSize=50&pageNum=1`, '', 'GET');
// 模糊搜索目标学校
export const getTargetSchoolApi = (value) => ajax(`${applets}/v1/academy/university/match?name=${value}&pageSize=50&pageNum=1`, '', 'GET');
// 模糊搜索专业
export const getSubjectApi = (value) => ajax(`${applets}/v1/academy/major/match?name=${value}&pageSize=50&pageNum=1`, '', 'GET');
// 新的模糊搜索专业
export const getNewSubjectApi = (value) => ajax(`${applets}/v1/academy/major/act/page?name=${value}&pageSize=50&pageNum=1`, '', 'GET');
//所有专业
export const getMatchmajorApi = () => ajax(`${head}/v1/academy/act/match-major`, '', 'GET');

//添加学员考试信息
export const postAcademyinfoApi = (data) => ajax(`${head}/v1/academy-info`,data, 'POST');

//获取学员考研择校信息详情
export const getAcademyinfodetailApi = (value) => ajax(`${head}/v1/academy-info/detail`, '', 'GET');

// 获取已经择校的人数
export const getAcademyCountApi = () => ajax(`${head}/v1/academy-info/academy-count`);

//添加用户压力测试结果
export const postPressureTestApi = (data) => ajax(`${head}/v1/pressure-test/add`,data, 'POST');